<template>
  <div :class="{'mobile-invite-buyer': isMobile}">
    <v-snackbar v-model="showInviteBuyerSnackbar" :timeout="4000" :top="true">
      {{ inviteBuyerSnackbarMessage }}
      <v-btn flat color="red" @click.stop="closeSnackbar()">
        Close
      </v-btn>
    </v-snackbar>
    <invite-buyer-form @on-modal-close="closeModal" />
  </div>
</template>

<script>
import InviteBuyerForm from '../../components/agent/invite/InviteBuyerForm.vue'
import { mapState } from 'vuex'

export default {
  components: { InviteBuyerForm },

  data: () => ({
    showInviteBuyerSnackbar: false,
    inviteBuyerSnackbarMessage: null
  }),
  computed: {
    ...mapState('common', ['isMobile'])

  },
  methods: {
    closeModal({ showMessage, message }) {
      this.showInviteBuyerSnackbar = true
      if (showMessage) this.inviteBuyerSnackbarMessage = message
      else this.inviteBuyerSnackbarMessage = null
    },

    closeSnackbar() {
      this.showInviteBuyerSnackbar = false
      this.inviteBuyerSnackbarMessage = null
    }
  }
}
</script>

<style lang="sass">
.mobile-invite-buyer
  height: 100vh
</style>
